import request from '@/router/axios';
export const add = (row) => {
return request({
url: '/api/produce/transport-record-ext/insert',
method: 'post',
data: row
})
}
export const update = (row) => {
return request({
url: '/api/produce/transport-record-ext/update',
method: 'post',
data: row
})
}
export const getDetail = (id) => {
return request({
url: '/api/produce/transport-record-ext/select/id',
method: 'get',
params: {
id
}
})
}
export const getList = (params) => {
return request({
url: '/api/produce/transport-record-ext/select/page',
method: 'get',
params
})
}
export const remove = (ids) => {
return request({
url: '/api/produce/transport-record-ext/delete/ids',
method: 'get',
params: {
ids
}
})
}

